export default "__VITE_ASSET__6f614686__"